/*
 * custom-postal-autofill.js
 * ------------------------------------------------------------------
 * 郵便番号入力欄に7桁入力されたら ZipCloud API から住所を取得し、
 * data-postal-target で指定された input / textarea に自動入力する。
 * 郵便番号を入れ直すと自動入力済みの住所は上書きされる（手入力された値は保護）。
 *
 * HTML 側 (単一ターゲット):
 *   <input data-postal-autofill data-postal-target="#address-id" ...>
 *
 * HTML 側 (都道府県 / 市区町村 を分割。町域は市区町村へ入る):
 *   <input data-postal-autofill
 *     data-postal-pref="#pref-id"
 *     data-postal-city="#city-id" ...>
 *
 * 依存: https://zipcloud.ibsnet.co.jp/api/search (無料・APIキー不要)
 *      失敗時はサイレントにスキップ (ユーザーが手入力可能)。
 */
(function () {
  if (window.__customPostalAutofillInit) return;
  window.__customPostalAutofillInit = true;

  var ENDPOINT = 'https://zipcloud.ibsnet.co.jp/api/search';
  var cache = {};

  function init() {
    var inputs = document.querySelectorAll('input[data-postal-autofill]');
    for (var i = 0; i < inputs.length; i++) {
      setupInput(inputs[i]);
    }
  }

  function setupInput(input) {
    if (input.dataset.postalAutofillApplied === 'true') return;
    input.dataset.postalAutofillApplied = 'true';

    var handler = function () {
      var digits = (input.value || '').replace(/[^0-9]/g, '');
      if (digits.length !== 7) return;
      lookup(digits, input);
    };
    input.addEventListener('input', handler);
    input.addEventListener('change', handler);
  }

  function lookup(zip, sourceInput) {
    var d = sourceInput.dataset;
    var has = d.postalTarget || d.postalPref || d.postalCity;
    if (!has) return;

    if (cache[zip]) {
      fill(cache[zip], d);
      return;
    }

    fetch(ENDPOINT + '?zipcode=' + encodeURIComponent(zip))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.status !== 200 || !data.results || !data.results[0]) return;
        var r = data.results[0];
        if (!r.address1 && !r.address2 && !r.address3) return;
        cache[zip] = r;
        fill(r, d);
      })
      .catch(function () { /* サイレントに失敗 */ });
  }

  // 町域 (address3) は市区町村側に含める。番地欄は手入力に任せる
  function fill(r, d) {
    var pref = r.address1 || '';
    var city = (r.address2 || '') + (r.address3 || '');
    if (d.postalPref) apply(pref, document.querySelector(d.postalPref));
    if (d.postalCity) apply(city, document.querySelector(d.postalCity));
    if (d.postalTarget) apply(pref + city, document.querySelector(d.postalTarget));
  }

  // 空欄、または前回自動入力した値のままなら上書きする（手入力は保護）
  function apply(addr, target) {
    if (!target || !addr) return;
    var current = (target.value || '').trim();
    if (current !== '' && current !== target.dataset.postalFilled) return;
    target.value = addr;
    target.dataset.postalFilled = addr;
    target.dispatchEvent(new Event('input', { bubbles: true }));
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
